export default Object.freeze({
    TODO: 'TODO',
    IN_PROGRESS: 'INPROGRESS',
    SENT: 'SENT',
    APPROVED: 'APPROVED',
    SUBMITTED: 'SUBMITTED',
});
